import { PortfoliosIcon } from '@virtus/components/icons';
import { Route } from '@virtus/components/page/models/route';

const subRouteLogs: Route[] = [
  {
    path: 'ErrorLog',
    name: 'Errors',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/ErrorLog',
  },
  {
    path: 'EventLog',
    name: 'Events',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/EventLog',
  },
  {
    path: 'SignalRLog',
    name: 'SignalR',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/SignalRLog',
  },
  {
    path: 'UserLog',
    name: 'User Login',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/UserLog',
  },
  {
    path: 'UserLogPage',
    name: 'User Log',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/UserLogPage',
  },
  {
    path: 'TelemetryLog',
    name: 'Telemetry',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/TelemetryLog',
  },
  {
    path: 'ReportActivityLog',
    name: 'Report Activity',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs/ReportActivityLog',
  },
];

const subRouteTools: Route[] = [
  {
    path: 'AddError',
    name: 'Add Manual Error (TEST)',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Tools/AddError',
  },
  {
    path: 'Application',
    name: 'Application Administration',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Tools/Application',
  },
  {
    path: 'DevOpsOutput',
    name: 'DevOps Output',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Tools/DevOpsOutput',
  },
];

const routes: Route[] = [
  {
    path: 'Home',
    name: 'Home',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Home',
  },
  {
    path: 'Logs',
    name: 'Logs',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Logs',
    subroutes: subRouteLogs,
  },
  {
    path: 'Tools',
    name: 'Tools',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/Tools',
    subroutes: subRouteTools,
  },
  {
    path: 'AppInsightDetails',
    name: 'Application Insights',
    icon: {
      component: PortfoliosIcon,
      sideBarProps: { style: { width: '22px', marginRight: '20px' } },
      enableInSideBar: true,
    },
    fullPath: '/AppInsightDetails',
  },
];

export default routes;
